<template>
  <amplify-authenticator class="authencation__popup"></amplify-authenticator>
</template>
<script>
import { AmplifyEventBus } from "aws-amplify-vue";
export default {
  created() {
    AmplifyEventBus.$on("authState", info => {
      if (info === "signedIn") {
        this.$router.push("/");
      }
    });
  }
};
</script>
<style lang="css">
  .authencation__popup {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }
</style>
